// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as AccessDeniedPage from "../Error/AccessDeniedPage.res.js";
import * as Notifier__Context from "../../bundles/Notifier/Notifier__Context.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as StockTransferRoutes from "./StockTransferRoutes.res.js";
import * as StockTransferListPage from "./StockTransferListPage.res.js";
import * as StockTransferCreatePage from "./StockTransferCreatePage.res.js";

function StockTransferRouter(props) {
  let subUrlPath = props.subUrlPath;
  let userRole = Auth.useRole();
  if (!Auth.isAuthorizedAccess(userRole, StockTransferRoutes.baseRoute)) {
    return JsxRuntime.jsx(AccessDeniedPage.make, {});
  }
  let tmp;
  tmp = subUrlPath !== 0 ? (
      subUrlPath.hd === "create" && subUrlPath.tl === 0 ? JsxRuntime.jsx(StockTransferCreatePage.make, {}) : JsxRuntime.jsx(Navigation.Redirect.make, {
          route: StockTransferRoutes.baseRoute
        })
    ) : JsxRuntime.jsx(StockTransferListPage.make, {
      stockTransferCreateRoute: StockTransferRoutes.createRoute
    });
  return JsxRuntime.jsx(Notifier__Context.Provider.make, {
    value: Notifier.createContext(),
    children: tmp
  });
}

let make = StockTransferRouter;

export {
  make,
}
/* Auth Not a pure module */
